import { createFileRoute } from "@tanstack/react-router";
import FormPlatformSessions from "@/components/company/form-platform-sessions";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/security",
)({
  component: SecurityPage,
});

function SecurityPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "companies", actions: ["read", "update"] }]}
    >
      <FormPlatformSessions />
    </RouteGuardPermissions>
  );
}